import { computed as k, openBlock as n, createElementBlock as s, normalizeClass as S, createCommentVNode as y, renderSlot as T, toDisplayString as f, createElementVNode as l, normalizeStyle as N, Fragment as M, renderList as D, createTextVNode as B, createVNode as E, withCtx as V, ref as I, watch as z, onMounted as O, onUnmounted as H, createBlock as L, Teleport as F, Transition as U, withModifiers as K, nextTick as j, withKeys as Q, unref as W, useModel as X, mergeModels as J } from "vue";
const x = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [u, d] of t)
    a[u] = d;
  return a;
}, Z = ["disabled"], ee = {
  key: 0,
  class: "tech-spinner"
}, te = {
  __name: "TechButton",
  props: {
    type: {
      type: String,
      default: "primary",
      validator: (e) => ["primary", "secondary", "danger", "ghost"].includes(e)
    },
    size: {
      type: String,
      default: "medium",
      validator: (e) => ["small", "medium", "large"].includes(e)
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    block: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const a = e, u = t, d = k(() => ({
      "tech-btn": !0,
      "tech-btn--primary": a.type === "primary",
      "tech-btn--secondary": a.type === "secondary",
      "tech-btn--danger": a.type === "danger",
      "tech-btn--ghost": a.type === "ghost",
      "tech-btn--small": a.size === "small",
      "tech-btn--medium": a.size === "medium",
      "tech-btn--large": a.size === "large",
      "tech-btn--block": a.block,
      "tech-btn--loading": a.loading
    })), h = () => {
      !a.disabled && !a.loading && u("click");
    };
    return (i, r) => (n(), s("button", {
      class: S(d.value),
      disabled: e.disabled || e.loading,
      onClick: h
    }, [
      e.loading ? (n(), s("span", ee)) : y("", !0),
      T(i.$slots, "default", {}, void 0, !0)
    ], 10, Z));
  }
}, A = /* @__PURE__ */ x(te, [["__scopeId", "data-v-240efe34"]]), ne = {
  key: 0,
  class: "tech-badge__dot"
}, ae = {
  key: 1,
  class: "tech-badge__icon"
}, se = { class: "tech-badge__text" }, le = {
  key: 2,
  class: "tech-badge__value"
}, oe = {
  __name: "TechBadge",
  props: {
    text: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "primary",
      validator: (e) => ["primary", "secondary", "success", "warning", "danger", "info"].includes(e)
    },
    icon: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    dot: {
      type: Boolean,
      default: !1
    },
    pill: {
      type: Boolean,
      default: !1
    },
    outline: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = k(() => ({
      "tech-badge--primary": t.type === "primary",
      "tech-badge--secondary": t.type === "secondary",
      "tech-badge--success": t.type === "success",
      "tech-badge--warning": t.type === "warning",
      "tech-badge--danger": t.type === "danger",
      "tech-badge--info": t.type === "info",
      "tech-badge--pill": t.pill,
      "tech-badge--outline": t.outline,
      "tech-badge--dot": t.dot,
      "tech-badge--has-value": t.value > 0
    }));
    return (u, d) => (n(), s("span", {
      class: S(["tech-badge", a.value])
    }, [
      e.dot ? (n(), s("span", ne)) : e.icon ? (n(), s("span", ae, f(e.icon), 1)) : y("", !0),
      l("span", se, f(e.text), 1),
      e.value ? (n(), s("span", le, f(e.value), 1)) : y("", !0)
    ], 2));
  }
}, ce = /* @__PURE__ */ x(oe, [["__scopeId", "data-v-b49e407e"]]), re = { class: "tech-progress-wrapper" }, ie = {
  key: 0,
  class: "tech-progress__label"
}, ue = { class: "tech-progress__text" }, de = { class: "tech-progress__value" }, he = { class: "tech-progress" }, fe = {
  key: 0,
  class: "tech-progress__stripes"
}, ye = {
  key: 1,
  class: "tech-progress__help"
}, ge = {
  __name: "TechProgress",
  props: {
    percent: {
      type: Number,
      default: 0,
      validator: (e) => e >= 0 && e <= 100
    },
    type: {
      type: String,
      default: "primary",
      validator: (e) => ["primary", "secondary", "success", "warning", "danger", "info"].includes(e)
    },
    label: {
      type: String,
      default: ""
    },
    showLabel: {
      type: Boolean,
      default: !0
    },
    showStriped: {
      type: Boolean,
      default: !1
    },
    animated: {
      type: Boolean,
      default: !1
    },
    help: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, a = k(() => ({
      "tech-progress__bar--primary": t.type === "primary",
      "tech-progress__bar--secondary": t.type === "secondary",
      "tech-progress__bar--success": t.type === "success",
      "tech-progress__bar--warning": t.type === "warning",
      "tech-progress__bar--danger": t.type === "danger",
      "tech-progress__bar--info": t.type === "info"
    })), u = k(() => `${t.percent}%`);
    return (d, h) => (n(), s("div", re, [
      e.showLabel ? (n(), s("div", ie, [
        l("span", ue, f(e.label), 1),
        l("span", de, f(u.value), 1)
      ])) : y("", !0),
      l("div", he, [
        l("div", {
          class: S(["tech-progress__bar", a.value]),
          style: N({ width: `${e.percent}%` })
        }, null, 6),
        e.showStriped && e.animated ? (n(), s("div", fe)) : y("", !0)
      ]),
      e.help ? (n(), s("span", ye, f(e.help), 1)) : y("", !0)
    ]));
  }
}, qn = /* @__PURE__ */ x(ge, [["__scopeId", "data-v-2f283126"]]), pe = {
  key: 0,
  class: "tech-card__header"
}, me = { key: 0 }, ve = { class: "tech-card__body" }, _e = {
  key: 1,
  class: "tech-card__footer"
}, be = {
  __name: "TechCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    glass: {
      type: Boolean,
      default: !1
    },
    glow: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = k(() => ({
      "tech-card": !0,
      "tech-card--glass": t.glass,
      "tech-card--glow": t.glow
    }));
    return (u, d) => (n(), s("div", {
      class: S(a.value)
    }, [
      e.title || u.$slots.header ? (n(), s("div", pe, [
        e.title ? (n(), s("h3", me, f(e.title), 1)) : y("", !0),
        T(u.$slots, "header", {}, void 0, !0)
      ])) : y("", !0),
      l("div", ve, [
        T(u.$slots, "default", {}, void 0, !0)
      ]),
      u.$slots.footer ? (n(), s("div", _e, [
        T(u.$slots, "footer", {}, void 0, !0)
      ])) : y("", !0)
    ], 2));
  }
}, Kn = /* @__PURE__ */ x(be, [["__scopeId", "data-v-26f21a25"]]), $e = { class: "tech-table-wrapper" }, ke = {
  key: 0,
  class: "tech-table__th--select",
  style: { width: "48px" }
}, we = ["checked", ".indeterminate", "disabled"], Se = {
  key: 0,
  class: "sort-icon"
}, Te = {
  key: 0,
  class: "tech-table__td--select"
}, Ce = ["checked", "onChange"], xe = {
  key: 0,
  class: "empty-state"
}, Ie = { class: "empty-text" }, Me = {
  key: 1,
  class: "table-loading"
}, Be = {
  __name: "TechTable",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    striped: {
      type: Boolean,
      default: !1
    },
    bordered: {
      type: Boolean,
      default: !1
    },
    showEmpty: {
      type: Boolean,
      default: !0
    },
    emptyText: {
      type: String,
      default: "暂无数据"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    selectable: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Array,
      default: () => []
    },
    rowKey: {
      type: String,
      default: "id"
    }
  },
  emits: ["update:selected"],
  setup(e, { emit: t }) {
    const a = e, u = t, d = k(() => ({
      "tech-table": !0,
      "tech-table--striped": a.striped,
      "tech-table--bordered": a.bordered
    }));
    function h(v) {
      const m = {};
      return v.width && (m.width = typeof v.width == "number" ? `${v.width}px` : v.width), v.align && (m.textAlign = v.align), m;
    }
    function i(v, m) {
      return {
        "tech-table__row--even": m % 2 === 0 && a.striped,
        "tech-table__row--odd": m % 2 !== 0 && a.striped
      };
    }
    function r(v) {
      return v == null ? void 0 : v[a.rowKey];
    }
    function c(v) {
      const m = r(v);
      return m != null && a.selected.includes(m);
    }
    const o = k(
      () => a.data.length > 0 && a.data.every((v) => c(v))
    ), g = k(
      () => !o.value && a.data.some((v) => c(v))
    );
    function b(v) {
      u("update:selected", v);
    }
    function $(v, m) {
      const p = r(v);
      if (p == null) return;
      const w = new Set(a.selected);
      m ? w.add(p) : w.delete(p), b(Array.from(w));
    }
    function _(v) {
      if (v) {
        const m = new Set(a.selected);
        a.data.forEach((p) => {
          const w = r(p);
          w != null && m.add(w);
        }), b(Array.from(m));
      } else {
        const m = new Set(a.data.map(r).filter((p) => p != null));
        b(a.selected.filter((p) => !m.has(p)));
      }
    }
    return (v, m) => (n(), s("div", $e, [
      l("table", {
        class: S(d.value)
      }, [
        l("thead", null, [
          l("tr", null, [
            e.selectable ? (n(), s("th", ke, [
              l("input", {
                type: "checkbox",
                class: "tech-checkbox",
                checked: o.value,
                ".indeterminate": g.value,
                disabled: e.data.length === 0,
                onChange: m[0] || (m[0] = (p) => _(p.target.checked))
              }, null, 40, we)
            ])) : y("", !0),
            (n(!0), s(M, null, D(e.columns, (p) => (n(), s("th", {
              key: p.prop,
              style: N(h(p))
            }, [
              l("span", null, f(p.label), 1),
              p.sortable ? (n(), s("span", Se, "↕")) : y("", !0)
            ], 4))), 128))
          ])
        ]),
        l("tbody", null, [
          (n(!0), s(M, null, D(e.data, (p, w) => (n(), s("tr", {
            key: r(p) ?? w,
            class: S(i(p, w))
          }, [
            e.selectable ? (n(), s("td", Te, [
              l("input", {
                type: "checkbox",
                class: "tech-checkbox",
                checked: c(p),
                onChange: (C) => $(p, C.target.checked)
              }, null, 40, Ce)
            ])) : y("", !0),
            (n(!0), s(M, null, D(e.columns, (C) => (n(), s("td", {
              key: C.prop,
              style: N(h(C))
            }, [
              C.slot ? T(v.$slots, C.slot, {
                key: 0,
                row: p,
                index: w
              }, void 0, !0) : C.formatter ? (n(), s(M, { key: 1 }, [
                B(f(C.formatter(p, w)), 1)
              ], 64)) : (n(), s(M, { key: 2 }, [
                B(f(p[C.prop] ?? "-"), 1)
              ], 64))
            ], 4))), 128))
          ], 2))), 128))
        ])
      ], 2),
      e.showEmpty && e.data.length === 0 && !e.loading ? (n(), s("div", xe, [
        m[1] || (m[1] = l("div", { class: "empty-icon" }, "📋", -1)),
        l("div", Ie, f(e.emptyText), 1)
      ])) : y("", !0),
      e.loading ? (n(), s("div", Me, [...m[2] || (m[2] = [
        l("span", { class: "table-spinner" }, null, -1),
        l("span", { class: "table-loading-text" }, "加载中…", -1)
      ])])) : y("", !0)
    ]));
  }
}, jn = /* @__PURE__ */ x(Be, [["__scopeId", "data-v-7aa01256"]]), De = { class: "tech-filter" }, Pe = { class: "tech-filter__header" }, Ve = { class: "tech-filter__title" }, Le = { class: "tech-filter__body" }, Ne = { class: "tech-filter__row" }, Ee = { class: "tech-filter__label" }, Ae = ["value", "placeholder", "onInput"], ze = ["value", "onChange"], Ye = { value: "" }, Fe = ["value"], Re = ["value", "onChange"], Oe = {
  key: 3,
  class: "tech-filter__daterange"
}, He = ["value", "onChange"], Ue = ["value", "onChange"], qe = { class: "tech-filter__footer" }, Ke = {
  __name: "TechFilter",
  props: {
    title: {
      type: String,
      default: "筛选"
    },
    modelValue: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Array,
      default: () => []
    },
    showReset: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(e, { emit: t }) {
    const a = e, u = t;
    function d(r, c) {
      u("update:modelValue", {
        ...a.modelValue,
        [r]: c.target.value
      });
    }
    function h(r, c) {
      u("update:modelValue", {
        ...a.modelValue,
        [r]: c.target.value
      });
    }
    function i() {
      const r = {};
      a.fields.forEach((c) => {
        r[c.prop] = "", c.type === "daterange" && (r[c.prop + "Start"] = "", r[c.prop + "End"] = "");
      }), u("update:modelValue", r);
    }
    return (r, c) => (n(), s("div", De, [
      l("div", Pe, [
        l("span", Ve, f(e.title), 1),
        e.showReset ? (n(), s("button", {
          key: 0,
          class: "tech-filter__reset",
          onClick: i
        }, " 重置 ")) : y("", !0)
      ]),
      l("div", Le, [
        l("div", Ne, [
          (n(!0), s(M, null, D(e.fields, (o) => (n(), s("div", {
            key: o.prop,
            class: "tech-filter__item",
            style: N({ width: o.width || "auto" })
          }, [
            l("label", Ee, f(o.label), 1),
            o.type === "input" ? (n(), s("input", {
              key: 0,
              type: "text",
              value: e.modelValue[o.prop],
              placeholder: o.placeholder || `请输入${o.label}`,
              class: "tech-filter__input",
              onInput: (g) => d(o.prop, g)
            }, null, 40, Ae)) : o.type === "select" ? (n(), s("select", {
              key: 1,
              value: e.modelValue[o.prop],
              class: "tech-filter__select",
              onChange: (g) => h(o.prop, g)
            }, [
              l("option", Ye, "请选择" + f(o.label), 1),
              (n(!0), s(M, null, D(o.options, (g) => (n(), s("option", {
                key: g.value,
                value: g.value
              }, f(g.label), 9, Fe))), 128))
            ], 40, ze)) : o.type === "date" ? (n(), s("input", {
              key: 2,
              type: "date",
              value: e.modelValue[o.prop],
              class: "tech-filter__input",
              onChange: (g) => h(o.prop, g)
            }, null, 40, Re)) : o.type === "daterange" ? (n(), s("div", Oe, [
              l("input", {
                type: "date",
                value: e.modelValue[o.prop + "Start"],
                placeholder: "开始日期",
                class: "tech-filter__input",
                onChange: (g) => h(o.prop + "Start", g)
              }, null, 40, He),
              c[2] || (c[2] = l("span", { class: "tech-filter__separator" }, "~", -1)),
              l("input", {
                type: "date",
                value: e.modelValue[o.prop + "End"],
                placeholder: "结束日期",
                class: "tech-filter__input",
                onChange: (g) => h(o.prop + "End", g)
              }, null, 40, Ue)
            ])) : o.type === "slot" ? T(r.$slots, o.prop, { key: 4 }, void 0, !0) : y("", !0)
          ], 4))), 128))
        ])
      ]),
      l("div", qe, [
        E(A, {
          type: "ghost",
          onClick: c[0] || (c[0] = (o) => r.$emit("cancel"))
        }, {
          default: V(() => [...c[3] || (c[3] = [
            B("取消", -1)
          ])]),
          _: 1
        }),
        E(A, {
          type: "primary",
          onClick: c[1] || (c[1] = (o) => r.$emit("confirm"))
        }, {
          default: V(() => [...c[4] || (c[4] = [
            B("确定", -1)
          ])]),
          _: 1
        })
      ])
    ]));
  }
}, Gn = /* @__PURE__ */ x(Ke, [["__scopeId", "data-v-d4f17602"]]), je = { class: "tech-pagination" }, Ge = { class: "tech-pagination__info" }, We = ["value"], Je = ["value"], Qe = { class: "tech-pagination__nav" }, Xe = ["disabled"], Ze = ["onClick"], et = {
  key: 0,
  class: "tech-pagination__ellipsis"
}, tt = {
  key: 2,
  class: "tech-pagination__btn active"
}, nt = {
  key: 4,
  class: "tech-pagination__ellipsis"
}, at = ["disabled"], st = {
  __name: "TechPagination",
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100]
    }
  },
  emits: ["update:currentPage", "update:pageSize"],
  setup(e, { emit: t }) {
    const a = e, u = t, d = k(() => Math.ceil(a.total / a.pageSize) || 1);
    function h(o) {
      o >= 1 && o <= d.value && o !== a.currentPage && u("update:currentPage", o);
    }
    function i() {
      a.currentPage > 1 && u("update:currentPage", a.currentPage - 1);
    }
    function r() {
      a.currentPage < d.value && u("update:currentPage", a.currentPage + 1);
    }
    function c(o) {
      const g = Number(o.target.value);
      u("update:pageSize", g), u("update:currentPage", 1);
    }
    return (o, g) => (n(), s("div", je, [
      l("div", Ge, [
        l("span", null, "共 " + f(e.total) + " 条", 1),
        g[6] || (g[6] = l("span", { class: "tech-pagination__separator" }, "|", -1)),
        l("span", null, [
          g[4] || (g[4] = B(" 每页 ", -1)),
          l("select", {
            value: e.pageSize,
            class: "tech-pagination__pagesize",
            onChange: c
          }, [
            (n(!0), s(M, null, D(e.pageSizes, (b) => (n(), s("option", {
              key: b,
              value: b
            }, f(b), 9, Je))), 128))
          ], 40, We),
          g[5] || (g[5] = B(" 条 ", -1))
        ])
      ]),
      l("div", Qe, [
        l("button", {
          class: "tech-pagination__btn",
          disabled: e.currentPage <= 1,
          onClick: i
        }, [...g[7] || (g[7] = [
          l("span", { class: "tech-pagination__icon" }, "‹", -1)
        ])], 8, Xe),
        d.value <= 7 ? (n(!0), s(M, { key: 0 }, D(d.value, (b) => (n(), s("button", {
          key: b,
          class: S(["tech-pagination__btn", { active: e.currentPage === b }]),
          onClick: ($) => h(b)
        }, f(b), 11, Ze))), 128)) : (n(), s(M, { key: 1 }, [
          l("button", {
            class: S(["tech-pagination__btn", { active: e.currentPage === 1 }]),
            onClick: g[0] || (g[0] = (b) => h(1))
          }, " 1 ", 2),
          e.currentPage > 4 ? (n(), s("span", et, "...")) : y("", !0),
          e.currentPage > 3 ? (n(), s("button", {
            key: 1,
            class: "tech-pagination__btn",
            onClick: g[1] || (g[1] = (b) => h(e.currentPage - 1))
          }, f(e.currentPage - 1), 1)) : y("", !0),
          e.currentPage > 1 && e.currentPage < d.value ? (n(), s("button", tt, f(e.currentPage), 1)) : y("", !0),
          e.currentPage < d.value - 2 ? (n(), s("button", {
            key: 3,
            class: "tech-pagination__btn",
            onClick: g[2] || (g[2] = (b) => h(e.currentPage + 1))
          }, f(e.currentPage + 1), 1)) : y("", !0),
          e.currentPage < d.value - 3 ? (n(), s("span", nt, "...")) : y("", !0),
          l("button", {
            class: S(["tech-pagination__btn", { active: e.currentPage === d.value }]),
            onClick: g[3] || (g[3] = (b) => h(d.value))
          }, f(d.value), 3)
        ], 64)),
        l("button", {
          class: "tech-pagination__btn",
          disabled: e.currentPage >= d.value,
          onClick: r
        }, [...g[8] || (g[8] = [
          l("span", { class: "tech-pagination__icon" }, "›", -1)
        ])], 8, at)
      ])
    ]));
  }
}, Wn = /* @__PURE__ */ x(st, [["__scopeId", "data-v-416ea225"]]), lt = { class: "tech-menu" }, ot = { class: "tech-menu__list" }, ct = ["data-menu-id", "onClick"], rt = { class: "tech-menu__link" }, it = {
  key: 0,
  class: "arrow"
}, ut = ["onClick"], dt = {
  __name: "TechMenu",
  props: {
    menuItems: { type: Array, default: () => [] },
    activeItem: { type: String, default: "" }
  },
  emits: ["update:activeItem", "select"],
  setup(e, { emit: t }) {
    const a = e, u = t, d = I(null), h = I(0), i = I(0), r = k(() => {
      if (!d.value) return [];
      const _ = a.menuItems.find((v) => v.id === d.value);
      return (_ == null ? void 0 : _.children) || [];
    }), c = k(() => ({
      left: `${h.value}px`,
      top: `${i.value}px`
    }));
    function o() {
      d.value && j(() => {
        const _ = document.querySelector(`[data-menu-id="${d.value}"]`);
        if (_) {
          const v = _.getBoundingClientRect();
          h.value = v.left, i.value = v.bottom + 8;
        }
      });
    }
    z(d, () => {
      o();
    });
    function g(_) {
      _.children && _.children.length ? d.value === _.id ? d.value = null : d.value = _.id : (d.value = null, u("update:activeItem", _.id), u("select", _));
    }
    function b(_) {
      u("update:activeItem", _.id), u("select", _), d.value = null;
    }
    function $(_) {
      !_.target.closest(".tech-menu") && !_.target.closest(".tech-submenu") && (d.value = null);
    }
    return O(() => {
      document.addEventListener("click", $);
    }), H(() => {
      document.removeEventListener("click", $);
    }), (_, v) => (n(), s("nav", lt, [
      l("ul", ot, [
        (n(!0), s(M, null, D(e.menuItems, (m) => (n(), s("li", {
          key: m.id,
          class: S(["tech-menu__item", { active: e.activeItem === m.id, open: d.value === m.id }]),
          "data-menu-id": m.id,
          onClick: (p) => g(m)
        }, [
          l("button", rt, [
            B(f(m.label) + " ", 1),
            m.children && m.children.length ? (n(), s("span", it, "▼")) : y("", !0)
          ])
        ], 10, ct))), 128))
      ]),
      (n(), L(F, { to: "body" }, [
        E(U, { name: "submenu" }, {
          default: V(() => [
            d.value && r.value.length ? (n(), s("ul", {
              key: 0,
              class: "tech-submenu",
              style: N(c.value)
            }, [
              (n(!0), s(M, null, D(r.value, (m) => (n(), s("li", {
                key: m.id,
                class: S({ active: e.activeItem === m.id })
              }, [
                l("button", {
                  class: "tech-submenu__link",
                  onClick: K((p) => b(m), ["stop"])
                }, f(m.label), 9, ut)
              ], 2))), 128))
            ], 4)) : y("", !0)
          ]),
          _: 1
        })
      ]))
    ]));
  }
}, ht = /* @__PURE__ */ x(dt, [["__scopeId", "data-v-8b0b816c"]]), ft = { class: "tech-layout" }, yt = {
  key: 0,
  class: "tech-layout__sidebar"
}, gt = {
  key: 0,
  class: "tech-layout__header"
}, pt = { class: "tech-layout__header-left" }, mt = { class: "tech-layout__header-center" }, vt = { class: "tech-layout__header-right" }, _t = { class: "tech-layout__content" }, bt = {
  __name: "TechLayout",
  props: {
    showSidebar: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    layoutMode: { type: String, default: "top", validator: (e) => ["sidebar", "top"].includes(e) },
    navItems: { type: Array, default: () => [] },
    activeNav: { type: String, default: "" }
  },
  emits: ["update:activeNav"],
  setup(e, { emit: t }) {
    const a = e, u = t;
    I(!1);
    const d = I(a.activeNav);
    z(() => a.activeNav, (i) => d.value = i);
    function h(i) {
      d.value = i.id, u("update:activeNav", i.id);
    }
    return (i, r) => (n(), s("div", ft, [
      e.showSidebar && e.layoutMode === "sidebar" ? (n(), s("aside", yt, [
        T(i.$slots, "sidebar", {}, void 0, !0)
      ])) : y("", !0),
      l("main", {
        class: S(["tech-layout__main", { "tech-layout__main--top-nav": e.layoutMode === "top" }])
      }, [
        e.showHeader ? (n(), s("header", gt, [
          l("div", pt, [
            T(i.$slots, "header-left", {}, void 0, !0),
            e.layoutMode === "top" && e.navItems.length ? (n(), L(ht, {
              key: 0,
              menuItems: e.navItems,
              activeItem: d.value,
              "onUpdate:activeItem": r[0] || (r[0] = (c) => d.value = c),
              onSelect: h
            }, null, 8, ["menuItems", "activeItem"])) : y("", !0)
          ]),
          l("div", mt, [
            T(i.$slots, "header-center", {}, void 0, !0)
          ]),
          l("div", vt, [
            T(i.$slots, "header-right", {}, void 0, !0)
          ])
        ])) : y("", !0),
        l("div", _t, [
          T(i.$slots, "default", {}, void 0, !0)
        ])
      ], 2)
    ]));
  }
}, Jn = /* @__PURE__ */ x(bt, [["__scopeId", "data-v-9bc06740"]]), $t = { class: "tech-user" }, kt = {
  key: 0,
  class: "tech-user__dropdown"
}, wt = { class: "tech-user__menu" }, St = { class: "tech-user__menu-icon" }, Tt = { class: "tech-user__menu-icon" }, Ct = {
  __name: "TechUser",
  props: {
    layoutMode: {
      type: String,
      default: "top"
    }
  },
  emits: ["update:layoutMode", "toggleTheme"],
  setup(e, { emit: t }) {
    const a = e, u = t, d = I(!1), h = I(!0);
    function i() {
      d.value = !d.value;
    }
    function r() {
      h.value = !h.value, u("toggleTheme", h.value);
    }
    function c() {
      const b = a.layoutMode === "sidebar" ? "top" : "sidebar";
      u("update:layoutMode", b);
    }
    function o() {
      console.log("Logout"), d.value = !1;
    }
    function g(b) {
      b.target.closest(".tech-user") || (d.value = !1);
    }
    return O(() => {
      document.addEventListener("click", g);
    }), H(() => {
      document.removeEventListener("click", g);
    }), (b, $) => (n(), s("div", $t, [
      l("button", {
        class: S(["tech-user__avatar", { "tech-user__avatar--active": d.value }]),
        onClick: i
      }, [...$[0] || ($[0] = [
        l("span", { class: "tech-user__icon" }, "👤", -1)
      ])], 2),
      d.value ? (n(), s("div", kt, [
        l("div", wt, [
          $[2] || ($[2] = l("div", { class: "tech-user__menu-header" }, [
            l("span", { class: "tech-user__name" }, "管理员"),
            l("span", { class: "tech-user__role" }, "系统管理员")
          ], -1)),
          $[3] || ($[3] = l("div", { class: "tech-user__divider" }, null, -1)),
          l("button", {
            class: "tech-user__menu-item",
            onClick: r
          }, [
            l("span", St, f(h.value ? "🌙" : "☀️"), 1),
            l("span", null, f(h.value ? "切换亮色主题" : "切换暗色主题"), 1)
          ]),
          l("button", {
            class: "tech-user__menu-item",
            onClick: c
          }, [
            l("span", Tt, f(e.layoutMode === "sidebar" ? "📐" : "📊"), 1),
            l("span", null, f(e.layoutMode === "sidebar" ? "切换顶部菜单" : "切换侧边栏"), 1)
          ]),
          $[4] || ($[4] = l("div", { class: "tech-user__divider" }, null, -1)),
          l("button", {
            class: "tech-user__menu-item tech-user__menu-item--danger",
            onClick: o
          }, [...$[1] || ($[1] = [
            l("span", { class: "tech-user__menu-icon" }, "🚪", -1),
            l("span", null, "退出登录", -1)
          ])])
        ])
      ])) : y("", !0)
    ]));
  }
}, Qn = /* @__PURE__ */ x(Ct, [["__scopeId", "data-v-bc32611b"]]), xt = { class: "modal-header" }, It = { class: "modal-title" }, Mt = { class: "modal-body" }, Bt = {
  key: 0,
  class: "modal-footer"
}, Dt = {
  __name: "TechModal",
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    confirmText: {
      type: String,
      default: "确定"
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    showConfirm: {
      type: Boolean,
      default: !0
    },
    showCancel: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:visible", "confirm", "cancel"],
  setup(e, { emit: t }) {
    const a = e, u = t, d = I(null), h = I(null);
    z(() => a.visible, (c) => {
      var o;
      c ? (h.value = document.activeElement, j(() => {
        var g;
        (g = d.value) == null || g.focus();
      }), document.body.style.overflow = "hidden") : ((o = h.value) == null || o.focus(), document.body.style.overflow = "");
    });
    function i() {
      a.loading || (u("update:visible", !1), u("cancel"));
    }
    function r() {
      a.loading || u("confirm");
    }
    return (c, o) => (n(), L(F, { to: "body" }, [
      E(U, { name: "modal-fade" }, {
        default: V(() => [
          e.visible ? (n(), s("div", {
            key: 0,
            class: "modal-overlay",
            onClick: K(i, ["self"]),
            onKeydown: Q(i, ["escape"])
          }, [
            l("div", {
              class: "modal-content",
              tabindex: "0",
              ref_key: "modalRef",
              ref: d
            }, [
              l("div", xt, [
                l("h3", It, f(e.title), 1),
                l("button", {
                  class: "modal-close",
                  onClick: i,
                  "aria-label": "关闭"
                }, "×")
              ]),
              l("div", Mt, [
                T(c.$slots, "default", {}, void 0, !0)
              ]),
              e.showCancel || e.showConfirm ? (n(), s("div", Bt, [
                e.showCancel ? (n(), L(A, {
                  key: 0,
                  type: "ghost",
                  disabled: e.loading,
                  onClick: i
                }, {
                  default: V(() => [
                    B(f(e.cancelText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])) : y("", !0),
                e.showConfirm ? (n(), L(A, {
                  key: 1,
                  type: "primary",
                  loading: e.loading,
                  disabled: e.loading,
                  onClick: r
                }, {
                  default: V(() => [
                    B(f(e.confirmText), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])) : y("", !0)
              ])) : y("", !0)
            ], 512)
          ], 32)) : y("", !0)
        ]),
        _: 3
      })
    ]));
  }
}, Xn = /* @__PURE__ */ x(Dt, [["__scopeId", "data-v-4dac0635"]]), Pt = { class: "tech-toast-container" }, Vt = { class: "tech-toast__icon" }, Lt = { class: "tech-toast__message" }, Nt = ["onClick"], Et = {
  __name: "TechToast",
  props: {
    toasts: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:toasts"],
  setup(e, { emit: t }) {
    const a = e, u = t, d = I([]);
    z(() => a.toasts, (r) => {
      d.value = [...r];
    }, { immediate: !0, deep: !0 });
    function h(r) {
      return {
        success: "✓",
        warning: "⚠",
        error: "✕",
        info: "ℹ"
      }[r] || "ℹ";
    }
    function i(r) {
      const c = d.value.find((o) => o.id === r);
      c && (c.visible = !1, setTimeout(() => {
        u("update:toasts", d.value.filter((o) => o.id !== r));
      }, 200));
    }
    return (r, c) => (n(), L(F, { to: "body" }, [
      l("div", Pt, [
        (n(!0), s(M, null, D(e.toasts, (o) => (n(), s("div", {
          key: o.id,
          class: S(["tech-toast", [`tech-toast--${o.type}`, { "tech-toast--visible": o.visible }]]),
          style: N({ top: `${o.offset}px` })
        }, [
          l("span", Vt, f(h(o.type)), 1),
          l("span", Lt, f(o.message), 1),
          o.showClose ? (n(), s("button", {
            key: 0,
            class: "tech-toast__close",
            onClick: (g) => i(o.id)
          }, [...c[0] || (c[0] = [
            l("span", null, "×", -1)
          ])], 8, Nt)) : y("", !0)
        ], 6))), 128))
      ])
    ]));
  }
}, Zn = /* @__PURE__ */ x(Et, [["__scopeId", "data-v-3962955b"]]), At = { class: "tech-confirm" }, zt = { class: "tech-confirm__title" }, Yt = { class: "tech-confirm__message" }, Ft = { class: "tech-confirm__footer" }, Rt = {
  __name: "TechConfirm",
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "warning",
      validator: (e) => ["success", "warning", "error", "info"].includes(e)
    },
    confirmText: {
      type: String,
      default: "确定"
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    showCancel: {
      type: Boolean,
      default: !0
    },
    confirmType: {
      type: String,
      default: "primary",
      validator: (e) => ["primary", "secondary", "danger", "ghost"].includes(e)
    }
  },
  emits: ["update:visible", "confirm", "cancel"],
  setup(e, { emit: t }) {
    const a = e, u = t;
    function d(c) {
      return {
        success: "✓",
        warning: "⚠",
        error: "✕",
        info: "ℹ"
      }[c] || "ℹ";
    }
    function h() {
      u("update:visible", !1), u("confirm");
    }
    function i() {
      u("update:visible", !1), u("cancel");
    }
    function r(c) {
      c.key === "Escape" && a.visible && i();
    }
    return z(() => a.visible, (c) => {
      c ? document.body.style.overflow = "hidden" : document.body.style.overflow = "";
    }), O(() => {
      document.addEventListener("keydown", r);
    }), H(() => {
      document.removeEventListener("keydown", r), document.body.style.overflow = "";
    }), (c, o) => (n(), L(F, { to: "body" }, [
      e.visible ? (n(), s("div", {
        key: 0,
        class: "tech-confirm-overlay",
        onClick: K(i, ["self"])
      }, [
        l("div", At, [
          l("div", {
            class: S(["tech-confirm__icon", `tech-confirm__icon--${e.type}`])
          }, f(d(e.type)), 3),
          l("h3", zt, f(e.title), 1),
          l("p", Yt, f(e.message), 1),
          l("div", Ft, [
            e.showCancel ? (n(), L(A, {
              key: 0,
              type: "ghost",
              onClick: i
            }, {
              default: V(() => [
                B(f(e.cancelText), 1)
              ]),
              _: 1
            })) : y("", !0),
            E(A, {
              type: e.confirmType,
              onClick: h
            }, {
              default: V(() => [
                B(f(e.confirmText), 1)
              ]),
              _: 1
            }, 8, ["type"])
          ])
        ])
      ])) : y("", !0)
    ]));
  }
}, ea = /* @__PURE__ */ x(Rt, [["__scopeId", "data-v-fa6b6ee2"]]), Ot = { class: "tech-tooltip-wrapper" }, Ht = { class: "tech-tooltip__content" }, Ut = {
  __name: "TechTooltip",
  props: {
    content: {
      type: String,
      default: ""
    },
    placement: {
      type: String,
      default: "top",
      validator: (e) => ["top", "bottom", "left", "right"].includes(e)
    },
    type: {
      type: String,
      default: "default",
      validator: (e) => ["default", "primary", "success", "warning", "danger"].includes(e)
    }
  },
  setup(e) {
    const t = e, a = ref(!1), u = computed(() => ({
      "tech-tooltip--top": t.placement === "top",
      "tech-tooltip--bottom": t.placement === "bottom",
      "tech-tooltip--left": t.placement === "left",
      "tech-tooltip--right": t.placement === "right",
      "tech-tooltip--primary": t.type === "primary",
      "tech-tooltip--success": t.type === "success",
      "tech-tooltip--warning": t.type === "warning",
      "tech-tooltip--danger": t.type === "danger"
    }));
    return (d, h) => (n(), s("div", Ot, [
      l("span", {
        class: "tech-tooltip__trigger",
        onMouseenter: h[0] || (h[0] = (i) => a.value = !0),
        onMouseleave: h[1] || (h[1] = (i) => a.value = !1)
      }, [
        T(d.$slots, "default", {}, void 0, !0)
      ], 32),
      E(U, { name: "tooltip" }, {
        default: V(() => [
          W(a) ? (n(), s("div", {
            key: 0,
            class: S(["tech-tooltip", W(u)])
          }, [
            h[2] || (h[2] = l("span", { class: "tech-tooltip__arrow" }, null, -1)),
            l("span", Ht, f(e.content), 1)
          ], 2)) : y("", !0)
        ]),
        _: 1
      })
    ]));
  }
}, ta = /* @__PURE__ */ x(Ut, [["__scopeId", "data-v-720519f7"]]), qt = { class: "tech-input-wrapper" }, Kt = {
  key: 0,
  class: "tech-input__label"
}, jt = {
  key: 0,
  class: "tech-input__required"
}, Gt = {
  key: 0,
  class: "tech-input__prefix"
}, Wt = ["type", "value", "placeholder", "disabled", "readonly", "maxlength"], Jt = {
  key: 1,
  class: "tech-input__suffix"
}, Qt = {
  key: 1,
  class: "tech-input__error"
}, Xt = {
  key: 2,
  class: "tech-input__help"
}, Zt = {
  __name: "TechInput",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "text",
      validator: (e) => ["text", "password", "number", "email", "tel"].includes(e)
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    maxlength: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    showClear: {
      type: Boolean,
      default: !1
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, u = I(!1);
    function d(i) {
      a("update:modelValue", i.target.value);
    }
    function h() {
      a("update:modelValue", "");
    }
    return (i, r) => (n(), s("div", qt, [
      e.label ? (n(), s("label", Kt, [
        e.required ? (n(), s("span", jt, "*")) : y("", !0),
        B(f(e.label), 1)
      ])) : y("", !0),
      l("div", {
        class: S(["tech-input-group", { "tech-input-group--focused": u.value }])
      }, [
        e.prefix ? (n(), s("span", Gt, f(e.prefix), 1)) : y("", !0),
        l("input", {
          type: e.type,
          value: e.modelValue,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          maxlength: e.maxlength > 0 ? e.maxlength : void 0,
          class: "tech-input",
          onInput: d,
          onFocus: r[0] || (r[0] = (c) => u.value = !0),
          onBlur: r[1] || (r[1] = (c) => u.value = !1)
        }, null, 40, Wt),
        e.suffix && !i.$slots.suffix ? (n(), s("span", Jt, f(e.suffix), 1)) : y("", !0),
        T(i.$slots, "suffix", {}, void 0, !0),
        e.showClear && e.modelValue && !e.disabled ? (n(), s("button", {
          key: 2,
          class: "tech-input__clear",
          onClick: h
        }, " × ")) : y("", !0)
      ], 2),
      e.error ? (n(), s("span", Qt, f(e.error), 1)) : y("", !0),
      e.help ? (n(), s("span", Xt, f(e.help), 1)) : y("", !0)
    ]));
  }
}, na = /* @__PURE__ */ x(Zt, [["__scopeId", "data-v-2591328c"]]), en = { class: "tech-select-wrapper" }, tn = {
  key: 0,
  class: "tech-select__label"
}, nn = {
  key: 0,
  class: "tech-select__required"
}, an = {
  key: 0,
  class: "tech-select__value"
}, sn = {
  key: 1,
  class: "tech-select__placeholder"
}, ln = ["onClick"], on = {
  key: 0,
  class: "tech-select__empty"
}, cn = {
  key: 1,
  class: "tech-select__error"
}, rn = {
  key: 2,
  class: "tech-select__help"
}, un = {
  __name: "TechSelect",
  props: /* @__PURE__ */ J({
    modelValue: {
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ J(["change"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const a = t, u = I(null), d = I(null), h = I({}), i = e, r = X(e, "modelValue"), c = I(!1), o = I(!1), g = k(() => i.options.find((p) => p.value === r.value));
    function b() {
      i.disabled || (o.value = !o.value, c.value = !!o.value, o.value && j(v));
    }
    function $(p) {
      r.value = p.value, o.value = !1, a("change", p.value);
    }
    function _(p) {
      const w = p.target.closest(".tech-select-wrapper"), C = p.target.closest(".tech-select__dropdown");
      !w && !C && (o.value = !1, c.value = !1);
    }
    function v() {
      if (!u.value) return;
      const p = u.value.getBoundingClientRect(), w = window.innerHeight - p.bottom, R = w < 320 && p.top > w, q = {
        left: `${p.left}px`,
        minWidth: `${p.width}px`
      };
      R ? q.bottom = `${window.innerHeight - p.top + 4}px` : q.top = `${p.bottom + 4}px`, h.value = q;
    }
    function m() {
      o.value && v();
    }
    return z(r, () => {
      o.value = !1;
    }), O(() => {
      document.addEventListener("click", _), window.addEventListener("scroll", m, !0), window.addEventListener("resize", m);
    }), H(() => {
      document.removeEventListener("click", _), window.removeEventListener("scroll", m, !0), window.removeEventListener("resize", m);
    }), (p, w) => (n(), s("div", en, [
      e.label ? (n(), s("label", tn, [
        e.required ? (n(), s("span", nn, "*")) : y("", !0),
        B(f(e.label), 1)
      ])) : y("", !0),
      l("div", {
        ref_key: "triggerRef",
        ref: u,
        class: S(["tech-select", {
          "tech-select--focused": c.value,
          "tech-select--open": o.value,
          "tech-select--disabled": e.disabled
        }]),
        onClick: b
      }, [
        g.value ? (n(), s("span", an, f(g.value.label), 1)) : (n(), s("span", sn, f(e.placeholder), 1)),
        w[0] || (w[0] = l("span", { class: "tech-select__arrow" }, [
          l("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            l("path", {
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "1.5",
              d: "M6 8l4 4 4-4"
            })
          ])
        ], -1))
      ], 2),
      (n(), L(F, { to: "body" }, [
        E(U, { name: "dropdown" }, {
          default: V(() => [
            o.value ? (n(), s("div", {
              key: 0,
              ref_key: "dropdownRef",
              ref: d,
              class: "tech-select__dropdown",
              style: N(h.value)
            }, [
              (n(!0), s(M, null, D(e.options, (C) => (n(), s("div", {
                key: C.value,
                class: S(["tech-select__option", { "tech-select__option--selected": p.selectedValue === C.value }]),
                onClick: (R) => $(C)
              }, f(C.label), 11, ln))), 128)),
              e.options.length === 0 ? (n(), s("div", on, " 暂无选项 ")) : y("", !0)
            ], 4)) : y("", !0)
          ]),
          _: 1
        })
      ])),
      e.error ? (n(), s("span", cn, f(e.error), 1)) : y("", !0),
      e.help ? (n(), s("span", rn, f(e.help), 1)) : y("", !0)
    ]));
  }
}, aa = /* @__PURE__ */ x(un, [["__scopeId", "data-v-eb297090"]]), dn = {
  key: 0,
  class: "tech-stat-card__icon"
}, hn = { class: "tech-stat-card__body" }, fn = {
  key: 0,
  class: "tech-stat-card__title"
}, yn = { class: "tech-stat-card__value-row" }, gn = { class: "tech-stat-card__value" }, pn = {
  key: 0,
  class: "tech-stat-card__label"
}, mn = {
  key: 1,
  class: "tech-stat-card__trend"
}, vn = {
  __name: "TechStatCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [Number, String],
      default: 0
    },
    label: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "primary",
      validator: (e) => ["primary", "warning", "danger", "success"].includes(e)
    },
    trend: {
      type: Number,
      default: void 0
    },
    trendLabel: {
      type: String,
      default: ""
    },
    formatter: {
      type: Function,
      default: null
    }
  },
  setup(e) {
    const t = e, a = k(() => t.formatter ? t.formatter(t.value) : t.value ?? "-"), u = k(() => ({
      "tech-stat-card--primary": t.type === "primary",
      "tech-stat-card--warning": t.type === "warning",
      "tech-stat-card--danger": t.type === "danger",
      "tech-stat-card--success": t.type === "success"
    })), d = k(() => ({
      "tech-stat-card__trend--up": t.trend > 0,
      "tech-stat-card__trend--down": t.trend < 0,
      "tech-stat-card__trend--flat": t.trend === 0
    })), h = k(() => {
      if (t.trend === void 0) return "";
      const i = t.trend > 0 ? "↑" : t.trend < 0 ? "↓" : "-", r = t.trendLabel ? ` ${t.trendLabel}` : "";
      return `${i} ${Math.abs(t.trend)}%${r}`;
    });
    return (i, r) => (n(), s("div", {
      class: S(["tech-stat-card", u.value])
    }, [
      e.icon || i.$slots.icon ? (n(), s("div", dn, [
        T(i.$slots, "icon", {}, () => [
          B(f(e.icon), 1)
        ], !0)
      ])) : y("", !0),
      l("div", hn, [
        e.title || i.$slots.title ? (n(), s("div", fn, [
          T(i.$slots, "title", {}, () => [
            B(f(e.title), 1)
          ], !0)
        ])) : y("", !0),
        l("div", yn, [
          l("div", gn, [
            T(i.$slots, "value", {}, () => [
              B(f(a.value), 1)
            ], !0)
          ]),
          e.label ? (n(), s("div", pn, f(e.label), 1)) : y("", !0)
        ]),
        e.trend !== void 0 || i.$slots.trend ? (n(), s("div", mn, [
          T(i.$slots, "trend", {}, () => [
            l("span", {
              class: S(d.value)
            }, f(h.value), 3)
          ], !0)
        ])) : y("", !0)
      ])
    ], 2));
  }
}, sa = /* @__PURE__ */ x(vn, [["__scopeId", "data-v-50d45c7f"]]), _n = { class: "tech-alert-list" }, bn = {
  key: 0,
  class: "tech-alert-list__header"
}, $n = { key: 0 }, kn = { class: "tech-alert-list__body" }, wn = ["onClick"], Sn = { class: "tech-alert-list__content" }, Tn = { class: "tech-alert-list__top" }, Cn = { class: "tech-alert-list__title" }, xn = {
  key: 0,
  class: "tech-alert-list__time"
}, In = {
  key: 0,
  class: "tech-alert-list__description"
}, Mn = {
  key: 1,
  class: "tech-alert-list__tag"
}, Bn = {
  key: 0,
  class: "tech-alert-list__arrow"
}, Dn = {
  key: 0,
  class: "tech-alert-list__empty"
}, Pn = {
  __name: "TechAlertList",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    showArrow: {
      type: Boolean,
      default: !0
    },
    emptyText: {
      type: String,
      default: "暂无告警"
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const a = t;
    function u(r) {
      return {
        "tech-alert-list__item--unread": r.read === !1,
        [`tech-alert-list__item--${d(r)}`]: !0
      };
    }
    function d(r) {
      const c = r.level || r.type || "info";
      return ["emergency", "urgent", "danger", "critical"].includes(c) ? "danger" : ["important", "warning"].includes(c) ? "warning" : ["success", "resolved", "normal"].includes(c) ? "success" : "info";
    }
    function h(r) {
      return d(r);
    }
    function i(r, c) {
      a("click", r, c);
    }
    return (r, c) => (n(), s("div", _n, [
      e.title || r.$slots.header ? (n(), s("div", bn, [
        e.title ? (n(), s("h3", $n, f(e.title), 1)) : y("", !0),
        T(r.$slots, "header", {}, void 0, !0)
      ])) : y("", !0),
      l("div", kn, [
        (n(!0), s(M, null, D(e.data, (o, g) => (n(), s("div", {
          key: o.id || g,
          class: S(["tech-alert-list__item", u(o)]),
          onClick: (b) => i(o, g)
        }, [
          c[0] || (c[0] = l("div", { class: "tech-alert-list__indicator" }, null, -1)),
          l("div", Sn, [
            l("div", Tn, [
              l("span", Cn, f(o.title), 1),
              o.time ? (n(), s("span", xn, f(o.time), 1)) : y("", !0)
            ]),
            o.description ? (n(), s("div", In, f(o.description), 1)) : y("", !0),
            o.tag || o.level ? (n(), s("div", Mn, [
              E(ce, {
                text: o.tag || o.level,
                type: h(o),
                size: "small"
              }, null, 8, ["text", "type"])
            ])) : y("", !0)
          ]),
          e.showArrow ? (n(), s("div", Bn, "›")) : y("", !0)
        ], 10, wn))), 128)),
        e.data.length === 0 ? (n(), s("div", Dn, [
          T(r.$slots, "empty", {}, () => [
            l("span", null, f(e.emptyText), 1)
          ], !0)
        ])) : y("", !0)
      ])
    ]));
  }
}, la = /* @__PURE__ */ x(Pn, [["__scopeId", "data-v-14a04cd2"]]), Vn = {
  class: "tech-gauge__svg",
  viewBox: "0 0 200 120"
}, Ln = ["stroke", "stroke-dashoffset"], Nn = { class: "tech-gauge__ticks" }, En = ["x1", "y1", "x2", "y2"], An = { class: "tech-gauge__content" }, zn = {
  key: 0,
  class: "tech-gauge__unit"
}, Yn = {
  key: 1,
  class: "tech-gauge__label"
}, Fn = {
  __name: "TechGauge",
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    unit: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    formatter: {
      type: Function,
      default: null
    },
    size: {
      type: Number,
      default: 200
    },
    thresholds: {
      type: Array,
      default: () => [
        { max: 0.3, color: "var(--color-success)" },
        { max: 0.7, color: "var(--color-warning)" },
        { max: 1, color: "var(--color-danger)" }
      ]
    }
  },
  setup(e) {
    const t = e, a = k(() => Math.max(t.min, Math.min(t.max, t.value ?? t.min))), u = k(() => t.max === t.min ? 0 : (a.value - t.min) / (t.max - t.min)), d = k(() => t.formatter ? t.formatter(a.value) : Number.isInteger(a.value) ? a.value : a.value.toFixed(2)), h = k(() => {
      var b;
      for (const $ of t.thresholds)
        if (u.value <= $.max)
          return $.color;
      return ((b = t.thresholds[t.thresholds.length - 1]) == null ? void 0 : b.color) || "var(--color-primary)";
    }), i = Math.PI * 80, r = `${i} ${i}`, c = k(() => i * (1 - u.value)), o = k(() => ({
      width: `${t.size}px`,
      height: `${t.size * 0.65}px`
    })), g = k(() => {
      const b = [];
      for (let _ = 0; _ < 5; _++) {
        const v = Math.PI - _ / 4 * Math.PI, m = 72, p = 80;
        b.push({
          value: _,
          x1: 100 + m * Math.cos(v),
          y1: 100 - m * Math.sin(v),
          x2: 100 + p * Math.cos(v),
          y2: 100 - p * Math.sin(v)
        });
      }
      return b;
    });
    return (b, $) => (n(), s("div", {
      class: "tech-gauge",
      style: N(o.value)
    }, [
      (n(), s("svg", Vn, [
        $[0] || ($[0] = l("path", {
          d: "M 20 100 A 80 80 0 0 1 180 100",
          fill: "none",
          stroke: "rgba(255,255,255,0.08)",
          "stroke-width": "12",
          "stroke-linecap": "round"
        }, null, -1)),
        l("path", {
          class: "tech-gauge__progress",
          d: "M 20 100 A 80 80 0 0 1 180 100",
          fill: "none",
          stroke: h.value,
          "stroke-width": "12",
          "stroke-linecap": "round",
          "stroke-dasharray": r,
          "stroke-dashoffset": c.value
        }, null, 8, Ln),
        l("g", Nn, [
          (n(!0), s(M, null, D(g.value, (_) => (n(), s("line", {
            key: _.value,
            x1: _.x1,
            y1: _.y1,
            x2: _.x2,
            y2: _.y2,
            stroke: "rgba(255,255,255,0.3)",
            "stroke-width": "2"
          }, null, 8, En))), 128))
        ])
      ])),
      l("div", An, [
        l("div", {
          class: "tech-gauge__value",
          style: N({ color: h.value })
        }, f(d.value), 5),
        e.unit ? (n(), s("div", zn, f(e.unit), 1)) : y("", !0),
        e.label ? (n(), s("div", Yn, f(e.label), 1)) : y("", !0)
      ])
    ], 4));
  }
}, oa = /* @__PURE__ */ x(Fn, [["__scopeId", "data-v-135c0414"]]);
function G() {
  try {
    const e = localStorage.getItem("userInfo");
    return e ? JSON.parse(e) : null;
  } catch {
    return null;
  }
}
function ca(e) {
  localStorage.setItem("userInfo", JSON.stringify(e));
}
function ra() {
  localStorage.removeItem("userInfo"), localStorage.removeItem("token");
}
function ia() {
  return localStorage.getItem("token") || localStorage.getItem("project_token");
}
function ua(e) {
  localStorage.setItem("token", e);
}
function da() {
  var t;
  const e = G();
  return ((t = e == null ? void 0 : e.roles) == null ? void 0 : t.includes("platform_admin")) ?? !1;
}
function ha() {
  return !!localStorage.getItem("project_token");
}
function fa(e) {
  var a;
  const t = G();
  return ((a = t == null ? void 0 : t.permissions) == null ? void 0 : a.includes(e)) ?? !1;
}
function ya(e) {
  var a;
  const t = G();
  return ((a = t == null ? void 0 : t.roles) == null ? void 0 : a.includes(e)) ?? !1;
}
function Rn(e, t = "YYYY-MM-DD HH:mm:ss") {
  const a = typeof e == "string" || typeof e == "number" ? new Date(e) : e, u = a.getFullYear(), d = String(a.getMonth() + 1).padStart(2, "0"), h = String(a.getDate()).padStart(2, "0"), i = String(a.getHours()).padStart(2, "0"), r = String(a.getMinutes()).padStart(2, "0"), c = String(a.getSeconds()).padStart(2, "0");
  return t.replace("YYYY", String(u)).replace("MM", d).replace("DD", h).replace("HH", i).replace("mm", r).replace("ss", c);
}
function ga() {
  return Date.now();
}
function pa() {
  const e = /* @__PURE__ */ new Date();
  return new Date(e.getFullYear(), e.getMonth(), e.getDate());
}
function ma() {
  const e = /* @__PURE__ */ new Date();
  return new Date(e.getFullYear(), e.getMonth(), e.getDate(), 23, 59, 59, 999);
}
function va() {
  const e = /* @__PURE__ */ new Date(), t = e.getDay() || 7, a = e.getDate() - t + 1;
  return new Date(e.getFullYear(), e.getMonth(), a);
}
function _a() {
  const e = /* @__PURE__ */ new Date(), a = 7 - (e.getDay() || 7), u = new Date(e.getFullYear(), e.getMonth(), e.getDate() + a);
  return new Date(u.getFullYear(), u.getMonth(), u.getDate(), 23, 59, 59, 999);
}
function ba() {
  const e = /* @__PURE__ */ new Date();
  return new Date(e.getFullYear(), e.getMonth(), 1);
}
function $a() {
  const e = /* @__PURE__ */ new Date(), t = new Date(e.getFullYear(), e.getMonth() + 1, 0);
  return new Date(t.getFullYear(), t.getMonth(), t.getDate(), 23, 59, 59, 999);
}
function ka(e, t) {
  const a = t.getTime() - e.getTime();
  return Math.floor(a / (1e3 * 60 * 60 * 24));
}
function wa(e) {
  const t = typeof e == "string" || typeof e == "number" ? new Date(e) : e, a = /* @__PURE__ */ new Date();
  return t.toDateString() === a.toDateString();
}
function Sa(e) {
  const t = Math.floor(e / 3600), a = Math.floor(e % 3600 / 60), u = e % 60;
  return `${String(t).padStart(2, "0")}:${String(a).padStart(2, "0")}:${String(u).padStart(2, "0")}`;
}
function Ta(e) {
  const t = typeof e == "string" || typeof e == "number" ? new Date(e) : e, u = (/* @__PURE__ */ new Date()).getTime() - t.getTime(), d = 60 * 1e3, h = 60 * d, i = 24 * h, r = 7 * i;
  return u < d ? "刚刚" : u < h ? `${Math.floor(u / d)}分钟前` : u < i ? `${Math.floor(u / h)}小时前` : u < r ? `${Math.floor(u / i)}天前` : Rn(t, "YYYY-MM-DD");
}
const Y = I([]);
let On = 0;
function Ca() {
  function e(i) {
    const r = ++On, c = {
      id: r,
      message: i.message,
      type: i.type || "info",
      duration: i.duration || 3e3,
      showClose: i.showClose ?? !0,
      visible: !0
    };
    return Y.value.push(c), c.duration > 0 && setTimeout(() => {
      t(r);
    }, c.duration), r;
  }
  function t(i) {
    const r = Y.value.find((c) => c.id === i);
    r && (r.visible = !1, setTimeout(() => {
      Y.value = Y.value.filter((c) => c.id !== i);
    }, 200));
  }
  function a(i, r) {
    return e({ message: i, type: "success", ...r });
  }
  function u(i, r) {
    return e({ message: i, type: "error", ...r });
  }
  function d(i, r) {
    return e({ message: i, type: "warning", ...r });
  }
  function h(i, r) {
    return e({ message: i, type: "info", ...r });
  }
  return {
    toasts: Y,
    show: e,
    remove: t,
    success: a,
    error: u,
    warning: d,
    info: h
  };
}
const P = I({
  visible: !1,
  title: "",
  message: "",
  type: "warning",
  confirmText: "确定",
  cancelText: "取消",
  showCancel: !0,
  confirmType: "primary",
  resolve: null
});
function xa() {
  function e(c) {
    return new Promise((o) => {
      P.value = {
        visible: !0,
        title: c.title || "",
        message: c.message,
        type: c.type || "warning",
        confirmText: c.confirmText || "确定",
        cancelText: c.cancelText || "取消",
        showCancel: c.showCancel ?? !0,
        confirmType: c.confirmType || "primary",
        resolve: o
      };
    });
  }
  function t() {
    P.value.resolve && P.value.resolve(!0), P.value.visible = !1, P.value.resolve = null;
  }
  function a() {
    P.value.resolve && P.value.resolve(!1), P.value.visible = !1, P.value.resolve = null;
  }
  function u(c, o) {
    return e({
      message: c,
      showCancel: !1,
      ...o
    });
  }
  function d(c, o) {
    return e({
      message: c,
      type: "success",
      ...o
    });
  }
  function h(c, o) {
    return e({
      message: c,
      type: "warning",
      ...o
    });
  }
  function i(c, o) {
    return e({
      message: c,
      type: "error",
      ...o
    });
  }
  function r(c, o) {
    return e({
      message: c,
      type: "info",
      ...o
    });
  }
  return {
    state: P,
    show: e,
    confirm: t,
    cancel: a,
    alert: u,
    success: d,
    warning: h,
    error: i,
    info: r
  };
}
function Hn(e) {
  import("./index-DsoY-VIl.js").then(({
    TechButton: t,
    TechCard: a,
    TechLayout: u,
    TechInput: d,
    TechSelect: h,
    TechTable: i,
    TechModal: r,
    TechToast: c,
    TechConfirm: o,
    TechPagination: g,
    TechFilter: b,
    TechBadge: $,
    TechProgress: _,
    TechTooltip: v,
    TechMenu: m,
    TechUser: p,
    TechStatCard: w,
    TechAlertList: C,
    TechGauge: R
  }) => {
    e.component("TechButton", t), e.component("TechCard", a), e.component("TechLayout", u), e.component("TechInput", d), e.component("TechSelect", h), e.component("TechTable", i), e.component("TechModal", r), e.component("TechToast", c), e.component("TechConfirm", o), e.component("TechPagination", g), e.component("TechFilter", b), e.component("TechBadge", $), e.component("TechProgress", _), e.component("TechTooltip", v), e.component("TechMenu", m), e.component("TechUser", p), e.component("TechStatCard", w), e.component("TechAlertList", C), e.component("TechGauge", R);
  });
}
const Ia = {
  install: Hn
};
export {
  la as TechAlertList,
  ce as TechBadge,
  A as TechButton,
  Kn as TechCard,
  ea as TechConfirm,
  Gn as TechFilter,
  oa as TechGauge,
  na as TechInput,
  Jn as TechLayout,
  ht as TechMenu,
  Xn as TechModal,
  Wn as TechPagination,
  qn as TechProgress,
  aa as TechSelect,
  sa as TechStatCard,
  jn as TechTable,
  Zn as TechToast,
  ta as TechTooltip,
  Qn as TechUser,
  ra as clearCurrentUser,
  ka as daysBetween,
  Ia as default,
  Rn as formatDate,
  Sa as formatDuration,
  G as getCurrentUser,
  $a as getMonthEnd,
  ba as getMonthStart,
  ga as getTimestamp,
  ma as getTodayEnd,
  pa as getTodayStart,
  ia as getToken,
  _a as getWeekEnd,
  va as getWeekStart,
  fa as hasPermission,
  ya as hasRole,
  Hn as install,
  da as isPlatformUser,
  ha as isProjectUser,
  wa as isToday,
  Ta as relativeTime,
  ca as setCurrentUser,
  ua as setToken,
  xa as useConfirm,
  Ca as useToast
};
